export function buildQuoteResponseRpcArgs({
  token,
  status,
  guestInfo = null,
  acceptanceContext = {},
}) {
  return {
    p_token: token,
    p_status: status,
    p_guest_name: guestInfo?.name || null,
    p_guest_email: guestInfo?.email || null,
    p_acceptance_typed_name: acceptanceContext.typedName || guestInfo?.name || null,
    p_acceptance_ip: acceptanceContext.ip || null,
    p_acceptance_user_agent: acceptanceContext.userAgent || null,
    p_acceptance_signature_data_url: acceptanceContext.signatureDataUrl || null,
  };
}

export function buildInvoiceResponseRpcArgs({
  token,
  action,
  paidMethod = null,
}) {
  return {
    p_token: token,
    p_action: action,
    p_paid_method: paidMethod,
  };
}
